import apiClient from "./axios"

export const login = async credentials => {
  const response = await apiClient.post("/login", credentials)
  return response.data
}

export const validateToken = async () => {
  const response = await apiClient.get("/validate-token")
  return response.data
}

export const logout = async () => {
  const response = await apiClient.post("/logout")
  return response.data
}
